import React, { useEffect, useState } from "react";
import "./contactUs.scss";
import sidebarActivePage from "../../stores/sidebarActivePage";
import TwoBreadcrumb from "../../components/breadcrumbs/TwoBreadcrumb";
import { Box, Paper, Tab } from "@mui/material";
import { TabContext, TabList, TabPanel } from "@mui/lab";
import AllContactUs from "./contactUsTabs/AllContactUs";
import contactUsStore from "../../stores/contactUsStore";
import NotRepliedContactUs from "./contactUsTabs/NotRepliedContactUs";
import RepliedContactUs from "./contactUsTabs/RepliedContactUs";

const ContactUs = () => {
  const SidebarActivePage = sidebarActivePage();
  const ContactUsStore = contactUsStore();
  const [activeTab, setActiveTab] = useState("1");
  const [dataLoading, setDataLoading] = useState(true);

  const [allContactUs, setAllContactUs] = useState(0);
  const [notRepliedContactUs, setNotRepliedContactUs] = useState(0);
  const [repliedContactUs, setRepliedContactUs] = useState(0);

  const [allData, setAllData] = useState(null);

  const handleChangeTab = (event, newValue) => {
    setActiveTab(newValue);
  };

  useEffect(() => {
    SidebarActivePage.setIsActive({ setPage: "Contact Us Via" });
  }, []);

  useEffect(() => {
    if (!ContactUsStore.isLoading) {
      if (ContactUsStore.contactUsList) {
        let all = 0;
        let not_replied = 0;
        let replied = 0;
        const data = [];
        ContactUsStore.contactUsList.map((item) => {
          all++;
          data.push(item);
          if (item.replied_at) {
            replied++;
          } else {
            not_replied++;
          }
        });

        setAllData(data);

        setAllContactUs(all);
        setNotRepliedContactUs(not_replied);
        setRepliedContactUs(replied);
        setDataLoading(false);
      } else {
        setDataLoading(false);
      }
    }
  }, [ContactUsStore.contactUsList, ContactUsStore.isLoading]);

  return (
    <div className="contact-us-via">
      <div className="heading">Contact Us</div>
      <TwoBreadcrumb
        mainName="Contact Us"
        mainLink="contact-us-via"
        activeName="List"
      />

      <Paper sx={{ width: "100%", mb: 2, mt: 4 }}>
        <TabContext value={activeTab}>
          <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
            <TabList
              onChange={handleChangeTab}
              aria-label="lab API tabs example"
              className="tab-list"
              variant="scrollable"
            >
              <Tab
                className="tab"
                label={
                  <p className={activeTab === "1" ? "all-contact-us" : ""}>
                    All <span className="all">{allContactUs}</span>
                  </p>
                }
                value="1"
              />
              <Tab
                className="tab"
                label={
                  <p
                    className={
                      activeTab === "2" ? "not-replied-contact-us" : ""
                    }
                  >
                    Pending Replied{" "}
                    <span className="not-replied">{notRepliedContactUs}</span>
                  </p>
                }
                value="2"
              />
              <Tab
                className="tab"
                label={
                  <p className={activeTab === "3" ? "replied-contact-us" : ""}>
                    Replied <span className="replied">{repliedContactUs}</span>
                  </p>
                }
                value="3"
              />
            </TabList>
          </Box>
          <TabPanel value="1">
            <AllContactUs dataLoading={dataLoading} allData={allData} />
          </TabPanel>
          <TabPanel value="2">
            <NotRepliedContactUs dataLoading={dataLoading} allData={allData} />
          </TabPanel>
          <TabPanel value="3">
            <RepliedContactUs dataLoading={dataLoading} allData={allData} />
          </TabPanel>
        </TabContext>
      </Paper>
    </div>
  );
};

export default ContactUs;
